import { render, staticRenderFns } from "./OrdersView.vue?vue&type=template&id=63f1335c&scoped=true"
import script from "./OrdersView.vue?vue&type=script&lang=js"
export * from "./OrdersView.vue?vue&type=script&lang=js"
import style0 from "./OrdersView.vue?vue&type=style&index=0&id=63f1335c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f1335c",
  null
  
)

export default component.exports